import { CheckIcon } from "../../../assets/icons";
import CongratsGif from "../../../assets/icons/congrats.gif";
import CongratsGif2 from '../../../assets/icons/congrats1.gif';
import styles from "./CongratulationsDialog.module.scss";

export interface CongratulationsDialogProps {
	title?: React.ReactNode | string;
	description: React.ReactNode | string;
	onConfirm: () => void;
	btnText?: React.ReactNode | string;
}

const CongratulationsDialog: React.FC<CongratulationsDialogProps> = ({
	title = "Congratulations",
	description,
	onConfirm,
	btnText = "Confirm",
}) => {

    const handleOnCLick =() =>{
        onConfirm()
    }
	return (
		<div className={styles.container}>
            <img src={CongratsGif2} className={styles.gifImage} style={{
                left: '5%'
            }} />
            <img src={CongratsGif2} className={styles.gifImage} style={{
                right: '5%'
            }} />
			<img className={styles.gifImage} style={{
                 left: '5%'
            }} src={CongratsGif} />
			<img className={styles.gifImage} style={{
                 right: '5%'
            }} src={CongratsGif} />
			<img className={styles.gifImage} style={{
                 top: '5%'
            }} src={CongratsGif} />
			<div className={styles.wrapper}>
				<div className={styles.checkCircle}>
					<CheckIcon />
				</div>
				<div className={styles.title}>{title}</div>
				<div className={styles.description}>{description}</div>
				<button disabled={false} className={styles.confirmButton} onClick={handleOnCLick}>
					{btnText}
				</button>
			</div>
		</div>
	);
};

export default CongratulationsDialog;
